import React from 'react'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Bio } from '../details/data';
import "../styles/Footer.css"

const Footer = () => {
  return (
    <div className='footer'>
        <a href={Bio.linkedin} target='_blank' className='icons' rel='noreferrer'>
            <LinkedInIcon style={{fontSize : "30px"}}/>
            <p>LinkedIn</p>
        </a>
        <a href={Bio.facebook} target='_blank' className='icons' rel='noreferrer'>
            <FacebookIcon style={{fontSize : "30px"}}/>
            <p>Facebook</p>
        </a>
        <a href={Bio.twitter} target='_blank' className='icons' rel='noreferrer'>
            <XIcon style={{fontSize : "30px"}}/>
            <p>Twitter</p>
        </a>
        <a href={Bio.insta} target='_blank' className='icons' rel='noreferrer'>
            <InstagramIcon style={{fontSize : "30px"}}/>
            <p>Instagram</p>
        </a>
    </div>
  )
}

export default Footer
